var map = {
	"./descarga.svg": "f471",
	"./facebook.svg": "761d",
	"./icon_apuntes.svg": "4f22",
	"./icon_basurero.svg": "fc14",
	"./icon_expandir_modulo.svg": "fe8a",
	"./icono_audio.svg": "9838",
	"./icono_candado_desbloqueado.svg": "4a1e",
	"./icono_certificate.svg": "c047",
	"./icono_clases.svg": "78a8",
	"./icono_estrella_valoracion_yellow.svg": "13fc",
	"./images/DiabetesThanks.svg": "f3df",
	"./images/icons/Facebook.svg": "9113",
	"./images/icons/arrow.svg": "2a39",
	"./images/icons/chevron.svg": "2f6a",
	"./images/icons/clock.svg": "9d77",
	"./images/icons/download.svg": "c28f",
	"./images/icons/email.svg": "7267",
	"./images/icons/instagram.svg": "9ec4",
	"./images/icons/people.svg": "88cd",
	"./images/icons/phone.svg": "ce8e",
	"./images/icons/plus.svg": "5273",
	"./images/icons/recurso_signos.svg": "157e",
	"./images/icons/trash.svg": "d1dc",
	"./images/logo.svg": "c7b0",
	"./images/recurso_inferior.svg": "575c",
	"./images/recurso_superior.svg": "fdb9",
	"./plus.svg": "bdef",
	"./speaker.svg": "9eef",
	"./usuario.svg": "0707"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0f8b";